export default "__VITE_ASSET__CtQVk_3K__"